export default "__VITE_ASSET__6fafffed__"